import { render, staticRenderFns } from "./SectionImage.vue?vue&type=template&id=338ca741&"
import script from "./SectionImage.vue?vue&type=script&lang=js&"
export * from "./SectionImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports